export default __webpack_public_path__ + "static/media/vaso-reto.253afba5.svg";